import { createTransform } from 'redux-persist';

import type {
  DeviceOrderConfirmationDetails,
  DeviceOrderPreviewPayload,
} from './catalogSlice.types';

/**
 * Returns device order confirmation safe to write to localStorage (no shipping
 * PII). In-memory Redux may still hold the address for the active session.
 */
export const deviceOrderConfirmationForPersist = (
  deviceOrderConfirmation: DeviceOrderConfirmationDetails | null | undefined
): DeviceOrderConfirmationDetails | null => {
  if (!deviceOrderConfirmation) {
    return null;
  }

  const { shippingAddress: _shippingAddress, ...rest } =
    deviceOrderConfirmation;

  return rest;
};

/**
 * Returns device order preview safe to write to localStorage (no shipping PII).
 */
export const deviceOrderPreviewForPersist = (
  deviceOrderPreview: DeviceOrderPreviewPayload | null | undefined
): DeviceOrderPreviewPayload | null => {
  if (!deviceOrderPreview) {
    return null;
  }

  const {
    shippingAddress: _shippingAddress,
    saveShippingAddress: _saveShippingAddress,
    ...rest
  } = deviceOrderPreview;

  return rest;
};

/**
 * Strips shipping address from persisted device order confirmation.
 */
export const deviceOrderConfirmationPersistTransform = createTransform(
  deviceOrderConfirmationForPersist,
  deviceOrderConfirmationForPersist,
  { whitelist: ['deviceOrderConfirmation'] }
);

/**
 * Strips shipping name/phone/address from persisted device order preview.
 * In-memory Redux may still hold these fields for the active checkout session.
 */
export const deviceOrderPreviewPersistTransform = createTransform(
  deviceOrderPreviewForPersist,
  deviceOrderPreviewForPersist,
  { whitelist: ['deviceOrderPreview'] }
);
